//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BackendServices from "@/services/backend-services.js";
import UploadsTable from "@/pages/FileUploads/components/UploadsTable.vue";
import UploadForm from "@/pages/FileUploads/components/UploadForm.vue";
import FileUploadInformation from "@/pages/FileUploads/components/FileUploadInformation.vue";
import FileSaver from "file-saver";
import moment from "moment";
import { Feedback } from "@/utils/notify-toaster.js";
import { fileNameFromContent } from "@/utils/name-parser.js";

export default {
  name: "FileUploads",
  components: {
    UploadsTable,
    UploadForm,
    FileUploadInformation,
  },
  props: {
    propDate: {
      type: String,
      default: null,
    },
  },
  mounted: function () {
    this.isLoading = true;
    BackendServices.getFileUploadDataTypes().then((response) => {
      this.fileDataTypes = response.data;
      this.tab = this.fileDataTypes[0].id;
    });
    this.nextSyncTime();

    this.getConfigs();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },

  data: () => ({
    tab: null,
    timer: null,
    data: [],
    uploadForm: false,
    newUploadClicked: false,
    existingUploadClicked: false,
    retailer: null,
    fileDataTypes: [],
    date: null,
    uploadFile: null,
    lineItem: null,
    recordsTotal: null,
    filterState: null,
    isLoading: false,
    pagination: {
      page: 1,
      rowsPerPage: 10,
      recordsTotal: 0,
    },
    syncRange: moment(new Date()).format("YYYY-MM-DD"),
    downloadRange: moment(new Date()).format("YYYY-MM-DD"),
    retailerList: [],
    selectedDownloadRetailer: null,
    scheduleSync: false,
    scheduleTimeDate: moment(new Date()).format("YYYY-MM-DD HH:mm"),
    massUploadState: false,
    massUploadLoading: false,
    setupStatusLoading: false,
    autoSyncLoading: false,
    setupStatusState: null,
    deleteFileUploadInfo: null,
    autoSyncData: {},
    autoSyncState: false,
    deleteFileUploadDateConfirmation: moment(new Date()).format("YYYY-MM-DD"),
    deleteCreatedEntitiesForFileUpload: false,
    nextSync: null,
    alertSyncNow: false,
  }),
  methods: {
    getConfigs() {
      //Facilmente optimizável
      this.massUploadLoading = true;
      this.setupStatusLoading = true;
      this.autoSyncLoading = true;
      BackendServices.getConfig("mass_stock_upload").then((response) => {
        this.massUploadState = response.data["mass_stock_upload"];
        this.massUploadLoading = false;
      });
      BackendServices.getConfig("setup_status").then((response) => {
        this.setupStatusState = response.data["setup_status"];
        this.setupStatusLoading = false;
      });
      BackendServices.getConfig("sync_databases").then((response) => {
        this.autoSyncData = response.data;
        this.autoSyncState = response.data["sync_databases"];
        this.autoSyncLoading = false;
      });
    },
    refreshTable: function () {
      this.askForData({ pagination: this.pagination });
      this.nextSyncTime();
    },
    askForData: function (event) {
      this.pagination = event.pagination;
      this.isLoading = true;
      let dateSearchObj = {
        date: event.searchDate,
        searchDateType: event.searchDateType,
      };
      if (event.searchDate === null) {
        dateSearchObj = null;
      }
      BackendServices.getFileUploads(
        event.pagination,
        event.filter,
        this.tab,
        dateSearchObj
      ).then((response) => {
        this.data = Array.isArray(response.data) ? response.data : [];
        this.recordsTotal = response.headers["x-total-count"];
        this.isLoading = false;
      });
    },
    deleteSellout: function (event) {
      this.deleteFileUploadInfo = event;
      this.$modal.show("confirmDeleteFileUpload");
      // BackendServices.deleteSellout(id).then(() => {
      //   this.refreshTable();
      // });
    },
    deleteFileUpload: function () {
      //Verificar deleteFileUploadDateConfirmation == deleteFileUploadInfo.date
      //lancar delete
      if (
        this.deleteFileUploadDateConfirmation ===
        this.deleteFileUploadInfo.reference_date
      ) {
        Feedback.success("A remover dados sellout do ficheiro selecionado.");
        this.$modal.hide("confirmDeleteFileUpload");
        BackendServices.deleteSellout(this.deleteFileUploadInfo.id, this.deleteCreatedEntitiesForFileUpload).then(() => {
          this.deleteCreatedEntitiesForFileUpload = false;
          this.refreshTable();
          //deleteCreatedEntitiesForFileUpload
        });
      } else {
        Feedback.error(
          "A data de referencia do ficheiro selecionado não corresponde à data indicada."
        );
        this.$modal.hide("confirmDeleteFileUpload");
      }
    },
    createNewUpload: function () {
      this.newUploadClicked = true;
      this.existingUploadClicked = false;
    },
    renderRightSide(event) {
      this.existingUploadClicked = true;
      this.newUploadClicked = false;
      this.lineItem = event;
    },
    closeForm() {
      this.newUploadClicked = false;
      this.existingUploadClicked = false;
    },
    updateFile(event) {
      this.uploadFile = event;
    },
    submitFile() {
      this.uploadFile["userId"] = this.$store.getters.userId;

      BackendServices.uploadFile(this.uploadFile).then(() =>
        this.refreshTable()
      );
      this.closeForm();
    },
    syncButtonClick: function () {
      this.$modal.show("databuilderSync");
    },
    massDownload: function () {
      this.$modal.show("massDownload");
      BackendServices.getRetailersForFileUpload().then((response) => {
        this.retailerList = response.data;
        //Add all
        this.retailerList.unshift({ id: null, name: "Todos" });
      });
    },
    downloadSelectedFiles: function () {
      let retailer = this.selectedDownloadRetailer;
      let date = {};
      if (typeof this.downloadRange === "string") {
        date["max_date"] = this.downloadRange;
        date["min_date"] = this.downloadRange;
      } else if (typeof this.downloadRange === "object") {
        date["max_date"] = this.downloadRange.to;
        date["min_date"] = this.downloadRange.from;
      } else {
        Feedback.error("Erro na seleção da data de sincronização.");
      }

      let requestData = {
        retailer: retailer,
        date: date,
      };
      BackendServices.massFileUploadDownload(requestData).then((response) => {
        let name = fileNameFromContent(response.headers["content-disposition"]);
        FileSaver.saveAs(response.data, name);
      });
    },
    syncConfirm: async function () {
      let date = {};
      if (typeof this.syncRange === "string") {
        date["max_date"] = this.syncRange;
        date["min_date"] = this.syncRange;
      } else if (typeof this.syncRange === "object") {
        date["max_date"] = this.syncRange.to;
        date["min_date"] = this.syncRange.from;
      } else {
        Feedback.error("Erro na seleção da data de sincronização.");
      }
      let response = await BackendServices.syncDatabuilder(date, {
        isScheduled: this.scheduleSync,
        scheduledDateTime: this.scheduleTimeDate,
      });
      if (response.status === 200) {
        this.$modal.hide("databuilderSync");
      }
    },
    exportFilteredUploads: function () {
      let filters = [];
      if (this.filterState) {
        if (this.filterState.filters) {
          Object.values(this.filterState.filters).forEach((value) => {
            if (value.include && value.include.length > 0) {
              filters.push({ key: value.column_key, values: value.include });
            }
          });
        }
      }
      BackendServices.downloadFileUploadsList(
        filters.length ? filters : null
      ).then((response) => {
        FileSaver.saveAs(response.data, "fileUploads.xlsx");
      });
    },
    nextSyncTime: function () {
      BackendServices.getNextDataBuilderSync().then((response) => {
        this.nextSync = response.data["next_run"];
      });
    },
    fastSync: function () {
      this.alertSyncNow = false;
      //Post despoletar o sync now
      BackendServices.dataBuilderSyncNow();
      this.nextSync = null;
    },
    watchRequest: function () {
      let searchDate = null;
      let searchDateType = null;
      if (this.propDate) {
        searchDate = this.propDate;
        searchDateType = "ref_date";
      }
      this.askForData({
        pagination: { page: 1, rowsPerPage: 10 },
        filter: null,
        searchDateType: searchDateType,
        searchDate: searchDate,
      });
    },
  },
  watch: {
    tab: {
      handler: function () {
        this.watchRequest();
      },
    },
    propDate: function () {
      this.watchRequest();
    },

    massUploadState: function () {
      BackendServices.saveConfig("mass_stock_upload", {
        mass_stock_upload: this.massUploadState,
      }).then(() => {
        this.getConfigs();
      });
    },
    setupStatusState: function () {
      BackendServices.saveConfig("setup_status", {
        setup_status: this.setupStatusState,
      }).then(() => {
        this.getConfigs();
      });
    },
    autoSyncState: function () {
      this.autoSyncData["sync_databases"] = this.autoSyncState;
      BackendServices.saveConfig("sync_databases", this.autoSyncData).then(
        () => {
          this.getConfigs();
        }
      );
    },
  },
};
